module.exports = __webpack_public_path__ + "static/media/orangeMarker.c1bbdada.svg";